import React, { ReactNode } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { PartyType } from '../../../../../../../../../types/SMT';
import { Option } from '../../../../../../../../design-system/src/content/components/SearchPickerInput';
import { InsurancePolicy } from '../../../../../../types/AdvisoryReport';
import InsurancePolicyItemCard from './InsurancePolicyItemCard';

export interface InsurancePolicyItemProps {
  insurancePolicy: InsurancePolicy;
  partyType: PartyType;
  partyId?: string;
  index: number;
  withActions?: boolean;
  customRiskObjects?: Option[];
  controlled?: boolean;
  defaultIsOpen?: boolean;
  isDragDisabled?: boolean;
  hideAIBanner?: boolean;
  customActions?: ReactNode;
  withDocuments?: boolean;
  // Actions
  onEdit?: (insurancePolicy: InsurancePolicy) => void;
  onRemove?: (id: string, packageId?: string) => void;
}

const InsurancePolicyItem: React.FC<InsurancePolicyItemProps> = (props) => {
  const { index, insurancePolicy, withActions, controlled } = props;
  const isDragDisabled = props.isDragDisabled || !withActions || controlled;

  if (isDragDisabled) {
    return <InsurancePolicyItemCard {...props} />;
  }

  return (
    <Draggable
      key={insurancePolicy.id}
      draggableId={insurancePolicy.id}
      index={index}
    >
      {(provided) => <InsurancePolicyItemCard provided={provided} {...props} />}
    </Draggable>
  );
};

export default InsurancePolicyItem;
